import React from 'react'

import smartAutomationImg_ch from "../images/smartautomation/PLA_C2.png";
import smartAutomationImg_en from "../images/smartautomation/PLA_E2.png";

import smartAutomationFlow_ch from "../images/smartautomation/PLA_C1.png";
import smartAutomationFlow_en from "../images/smartautomation/PLA_E1.png";

const smartAutomationConfig = {
    ch:{
        title:'智慧自動化',
        intro1Title:'產線自動化',
        intro1List:[[
                    ['❶\xa0製程設計','防錯製程設計、加工模擬'],
                    ['❷\xa0生產排程','少量多樣，彈性生產排程']
                    ],
                    [
                    ['❸\xa0FAS, EMS','產線控管預告數位化、即時化、透明化'],
                    ['❹\xa0刀具資訊流','刀具壽命/刀具庫存管理']
                    ]
                    ],
        flowTitle:  <span>少量多樣<span style={{color:'red'}}>管理軟體</span></span>,
        flowImg:smartAutomationFlow_ch,
        intro2Title:<span><span style={{color:'red'}}>宜人化</span>-自動化兼顧人工作業</span>,
        intro2List:[[<span>▪ 安全設計，<span style={{color:'red'}}>可離線作業</span></span>,['- 模面檢視','- 單機加工','- 維修保養']],
                    ['▪\xa0托盤交換設計',['- 容易上下料','- 手臂程式簡單化',<span style={{color:'red'}}>- 快速換線換模</span>]]
                    ],
        img:smartAutomationImg_ch,
    },
    en:{
        title:'Smart Automation',
        intro1Title:'Production Line Automation',
        intro1List:[[
                    ['❶\xa0Operation Planning','Error-proofing process design, processing simulation'],
                    ['❷\xa0Production Scheduling ','Flexible production scheduling']
                    ],
                    [
                    ['❸\xa0FAS, EMS','Digitization, real-time, and transparency'],
                    ['❹\xa0Tool information flow','Tool life / Tool inventory management']
                    ]
                    ],
        flowTitle:'Management Software',
        flowImg:smartAutomationFlow_en,
        intro2Title:<span><span style={{color:'red'}}>User-friendly</span>- Connecting Automated and Manual Procedures</span>,
        intro2List:[[<span>▪ Safety design, <span style={{color:'red'}}>Offline procedures</span></span>,['- Surface check','- Single machine operation','- Maintenance']],
                    ['▪\xa0Pallet exchange',['- Easy loading, unloading','- Simplified robot programming',<span style={{color:'red'}}>- Quick line change</span>]]
                    ],
        img:smartAutomationImg_en,
    }
}

export default smartAutomationConfig;